/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'line-dash-dot-dot': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 2',
    data: '<path pid="0" stroke="currentColor" stroke-width="2" d="M0 1h6.5"/><circle pid="1" cx="9.5" cy="1" r="1.5" fill="currentColor" stroke-width="2"/><circle pid="2" cx="14.5" cy="1" r="1.5" fill="currentColor" stroke-width="2"/><path pid="3" stroke="currentColor" stroke-width="2" d="M17.5 1H24"/>',
    lastMod: '1659509843349.4507'
  }
})
